export default __webpack_public_path__ + "static/media/loader.7b53e9d9.gif";